import { Directive, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';

@Directive()
export abstract class Unsubscribe implements OnDestroy {
  ngUnsubscribe: Subject<any> = new Subject();

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    // this.ngUnsubscribe.complete(); No longer necessary to be garbage collected
  }
}
